export const UPDATES = [
  {
    id: '2026-05-20-guides',
    date: '2026-05-20',
    titleKey: 'updates_2026_05_20_title',
    bodyKeys: ['updates_2026_05_20_p1', 'updates_2026_05_20_p2'],
  },
  {
    id: '2026-05-19-staging',
    date: '2026-05-19',
    titleKey: 'updates_2026_05_19_title',
    bodyKeys: ['updates_2026_05_19_p1'],
  },
];

